import dayjs from "dayjs";
import { DATE_FORMAT } from "config/settings";

interface CounterpartWithCycle {
  [key: string]: unknown;
  id?: ID;
  code?: string;
  name?: string;
  remotePk?: ID;
  cycle?: {
    startDate?: string | null;
    endDate?: string | null;
    limitDate?: string | null;
  } | null;
}

interface OptionResult {
  label: React.ReactNode;
  value: string;
  data: CounterpartWithCycle;
}

export const createOptionCounterPartWithCycle = (item: Record<string, unknown>): OptionResult => {
  const counterpart: CounterpartWithCycle = item;
  const cycleInfo = counterpart?.cycle?.startDate
    ? `${dayjs(counterpart.cycle.startDate).format(DATE_FORMAT)} - ${dayjs(counterpart?.cycle?.endDate || counterpart?.cycle?.limitDate).format(DATE_FORMAT)}`
    : "";

  return {
    label: (
      <div>
        <div>{`${counterpart.code} - ${counterpart.name}`}</div>
        {cycleInfo && <small>{cycleInfo}</small>}
      </div>
    ),
    value: counterpart.code ?? "",
    data: counterpart,
  };
};
